import React from 'react';

class ControlSelector extends React.Component {
  constructor(props) {
    super(props);
    this.ulRef = React.createRef();
    this.componentDidUpdateCount = 0;
  }

  animatedScroll(dom, delta) {
    const x0 = dom.scrollLeft;
    const SCROLL_DURATION = 30;
    const stepX = Math.PI / SCROLL_DURATION;
    let stepCount = 0;

    const step = () => {
      if (stepCount < SCROLL_DURATION) {
        window.requestAnimationFrame(step);
        stepCount++;
        dom.scrollTo(
          x0 + 0.25 * delta * Math.pow(1 - Math.cos(stepX * stepCount), 2),
          0
        );
      }
    };
    window.requestAnimationFrame(step);
  }

  scrollLeft() {
    if (this.ulRef.current) this.animatedScroll(this.ulRef.current, -300);
  }

  scrollRight() {
    if (this.ulRef.current) this.animatedScroll(this.ulRef.current, 300);
  }

  scrollToSelected(behavior = 'smooth') {
    if (this.ulRef.current && this.props.controlId) {
      const el = this.ulRef.current.querySelector(`[data-id="${this.props.controlId}"]`);
      if (el) {
        el.scrollIntoView({ inline: 'center', block: 'nearest', behavior });
      }
    }
  }

  componentDidMount() {
    this.scrollToSelected('instant');
  }

  componentDidUpdate(prevProps) {
    if (parseInt(prevProps.controlId, 10) !== parseInt(this.props.controlId, 10)) {
      this.scrollToSelected();
    }
  }

  render() {
    const controlId = parseInt(this.props.controlId, 10);
    const controlList = this.props.controlList || [];
    const { showGeneroSelector } = this.props;

    return (
      <div className={`relative md:max-w-5xl md:mx-auto ${!showGeneroSelector ? 'mt-0 md:mt-0' : 'mt-0'}`}>
        <div className="overflow-x-auto hide-scrollbar md:scrollbar scroll-smooth" ref={this.ulRef}>
          <ul
            className="
              flex flex-nowrap items-stretch gap-2
              justify-start md:justify-center
              pl-4 pr-10 md:px-0 py-2 list-none
              w-max md:w-full
            "
          >
            {controlList.map((control) => {
              if (control.tipo === 'SALIDA') return null;
              const isSelected = parseInt(control.id, 10) === controlId;
              return (
                <li key={control.id} data-id={control.id} className="snap-start flex-none">
                  <button
                    onClick={() => this.props.navigateToControl(control.id)}
                    className={[
                      'min-w-[120px] max-w-[150px] px-4 py-2 rounded-md text-center cursor-pointer',
                      'transition-all duration-200 mt-2',
                      isSelected
                        ? 'bg-ccnorte text-white shadow-[0_4px_10px_rgba(0,0,0,0.25)]'
                        : 'ring-1 ring-white/10 text-white hover:text-gray-400'
                    ].join(' ')}
                  >
                    <div className="text-sm font-bold font-montserrat leading-none truncate">
                      {control.nombre}
                    </div>
                    <div
                      className={[
                        'mt-1 text-[10px] uppercase tracking-wider leading-tight truncate',
                        isSelected ? 'text-white' : 'text-white/75'
                      ].join(' ')}
                      dangerouslySetInnerHTML={{ __html: control.descripcion || '&nbsp;' }}
                    />
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default ControlSelector;
